import React from "react";

import {
  useFetchInvoiceDetails,
  useFetchPaymentTaxInvoice,
} from "store/backend/assets";
import { ErrorMessage, PrimaryButton, Table } from "widgets";
import { INVOICE_DETAILS_COLUMN } from "constants/config";
import Loader from "Shared/Loader/Loader";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import CloseIcon from "@mui/icons-material/Close";

import styles from "./DownloadInvoice.module.scss";

const handleOnClickDownloadInvoice = (
  invoiceNumber,
  fetchPaymentTaxInvoice,
  openSnackbar
) => {
  if (!invoiceNumber) {
    console.error("No invoice number provided");
    return;
  }

  fetchPaymentTaxInvoice(invoiceNumber)
    .then((response) => {
      const link = document.createElement("a");
      link.href = response.signedUrl;
      link.click();
      openSnackbar("Payment tax invoice downloaded successfully!", "success");
    })
    .catch((error) => {
      console.error("Error fetching tax invoice", error);
      openSnackbar(
        error.message || "Error fetching payment tax invoice",
        "error"
      );
    });
};

const getInvoiceDetails = (
  invoiceDetails,
  fetchPaymentTaxInvoice,
  isFetchingPaymentTaxInvoice,
  openSnackbar
) => {
  return invoiceDetails.map((invoice) => ({
    billingEntity: invoice.billing_entity,
    invoiceNumber: invoice.invoice_number,
    invoiceDate: invoice.invoice_generation_date,
    amount: invoice.invoice_amount,
    download: (
      <PrimaryButton
        onClick={() =>
          handleOnClickDownloadInvoice(
            invoice.invoice_number,
            fetchPaymentTaxInvoice,
            openSnackbar
          )
        }
      >
        {isFetchingPaymentTaxInvoice ? <Loader /> : "Download"}
      </PrimaryButton>
    ),
  }));
};

const DownloadInvoice = ({ onClose, paymentId }) => {
  const { openSnackbar } = useSnackbarContext();
  const {
    data: invoiceDetails,
    isPending: isInvoiceDetailsLoading,
    isError: isErrorOnInvoiceDetails,
    error: errorMessageOnInvoiceDetails,
  } = useFetchInvoiceDetails(paymentId);

  const { fetchPaymentTaxInvoice, isLoading: isFetchingPaymentTaxInvoice } =
    useFetchPaymentTaxInvoice();

  if (isErrorOnInvoiceDetails)
    return <ErrorMessage>{errorMessageOnInvoiceDetails.message}</ErrorMessage>;

  const invoiceDetailsRows = invoiceDetails
    ? getInvoiceDetails(
        invoiceDetails,
        fetchPaymentTaxInvoice,
        isFetchingPaymentTaxInvoice,
        openSnackbar
      )
    : [];

  return (
    <div className={styles.downloadInvoiceContainer}>
      {isInvoiceDetailsLoading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.header}>
            <CloseIcon
              className={styles.closeIcon}
              onClick={onClose}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className={styles.title}>Download Invoice</div>
          <div className={styles.horizontalLine} />
          <Table columns={INVOICE_DETAILS_COLUMN} rows={invoiceDetailsRows} />
        </>
      )}
    </div>
  );
};

export default DownloadInvoice;
